import { Repository, Pipeline } from 'src/components/pipelines/models';
import { fetchData } from 'src/components/pipelines/resources/utils';
import { jsonHeaders } from 'src/utils/fetch';

import envBaseUrl from './env-base-url';

export function createPipeline(
  repository: Repository,
  data: object
): Promise<Pipeline> {
  return fetchData(
    `${envBaseUrl('/!api/2.0')}/repositories/${repository.path}/pipelines/`,
    'create_pipeline_exception',
    {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(data),
    }
  );
}
